module.exports = __webpack_public_path__ + "img/fyt_p23.f495d427.png";